/**
 * Story types: continuous stream of requirements, spec, and building for one feature/bug.
 * Stories reference content items (summaries of external content, including chat threads).
 */

import { z } from 'zod';
import { CheckpointSummarySchema } from './checkpoints';

export const StoryMetaSchema = z.object({
  storyId: z.string(),
  workspaceId: z.string(),
  title: z.string(),
  /** feature | bug | epic */
  kind: z.enum(['feature', 'bug', 'epic']).default('feature'),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type StoryMeta = z.infer<typeof StoryMetaSchema>;

/** A content item reference within a story, with a snapshot summary */
export const StoryContentItemRefSchema = z.object({
  id: z.string(),
  storyId: z.string(),
  contentItemId: z.string(),
  /** Snapshot summary when added to story (or updated) */
  summary: z.string(),
  orderIndex: z.number().default(0),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type StoryContentItemRef = z.infer<typeof StoryContentItemRefSchema>;

export const StoryCheckpointSummarySchema = CheckpointSummarySchema.extend({
  storyId: z.string(),
});
export type StoryCheckpointSummary = z.infer<typeof StoryCheckpointSummarySchema>;
